export enum TenantBillingStatus {
  ACTIVE = "active",
  PAID = "paid",
  REMINDER = "reminder",
  OVERDUE = "overdue",
  TERMINATED = "terminated",
}

export const TenantBillingStatusInfo = {
  [TenantBillingStatus.ACTIVE]: { name: "Active" },
  [TenantBillingStatus.PAID]: { name: "Paid" },
  [TenantBillingStatus.REMINDER]: { name: "Due Soon" },
  [TenantBillingStatus.OVERDUE]: { name: "Overdue" },
  [TenantBillingStatus.TERMINATED]: { name: "Terminated" },
} as const;

export const getTenantBillingStatusName = (
  value: TenantBillingStatus,
): string => TenantBillingStatusInfo[value].name;
